export function initDropdown() {
  const dropdownButton = document.querySelector(".dropdown__button");
  const dropdownMenu = document.querySelector(".dropdown__menu");
  const selectedOption = document.querySelector(".dropdown__selected-option");
  const menuItems = document.querySelectorAll(".dropdown__menu-item");
  const renderingBlocks = document.querySelectorAll(
    ".possibilities__description"
  );
  const dropdownArrow = document.querySelector(".dropdown__button span img");

  if (
    !(
      dropdownButton &&
      dropdownMenu &&
      selectedOption &&
      menuItems.length &&
      renderingBlocks.length &&
      dropdownArrow
    )
  )
    return;

  // dropdown-menu
  dropdownButton.addEventListener("click", toggleDropdownMenu);
  menuItems.forEach(item => item.addEventListener("click", selectOption));

  function toggleDropdownMenu() {
    dropdownMenu.classList.toggle("show");
    dropdownArrow.classList.toggle("show");
  }

  function selectOption(event) {
    const selectedItem = event.currentTarget;

    const content = selectedItem.getAttribute("data-content");

    selectedOption.textContent = selectedItem.textContent;
    renderContent(content);

    toggleDropdownMenu();
  }

  // dropdown-content

  function renderContent(content) {
    renderingBlocks.forEach(block => {
      console.log(block.getAttribute("data-content"));

      if (block.getAttribute("data-content") === content) {
        block.style.display = "flex";
      } else {
        block.style.display = "none";
      }
    });
  }
}
